import { createContext } from 'react'

export interface SideNavContextValue {
  /**
   * The DOM node in `AdminShell` that a page's `SideNav` portals into. The shell owns the column
   * layout (rail on the left, top bar and content on the right), but each page decides whether
   * it has a rail at all — so the rail is rendered from inside the route and teleported into
   * place. `null` until the shell has mounted the slot.
   */
  slot: HTMLElement | null
  /** Icon-only rail when true; full labels when false. Owned by the shell, persisted locally. */
  isCollapsed: boolean
  /** True while a page has a `SideNav` mounted — the top bar shows the collapse toggle only then. */
  hasSideNav: boolean
  toggleCollapsed(): void
  setHasSideNav(hasSideNav: boolean): void
}

export const SideNavContext = createContext<SideNavContextValue>({
  slot: null,
  isCollapsed: false,
  hasSideNav: false,
  toggleCollapsed: () => {},
  setHasSideNav: () => {},
})
